export const favoriteConstants = {
    START: 'start',
    STOP: 'stop',
    FAVORITE: 'favorite',
    ADD: 'add',
    UPDATE: 'update',
    REMOVE: 'delete',
    CLEAR: 'clear',
};